export default __webpack_public_path__ + "static/media/header60.829b3362.jpg";